export default __webpack_public_path__ + "static/media/service_list2.94e4e42c.png";